export enum Issuer {
  // Auth0 = 'Auth0',
  // Firebase = 'Firebase',
  JWT = 'JWT',
  // Amplify = 'Amplify'
}
